import * as constants from '../constants/constants';

const defaultStore = {
  folders: [],
  onAllFolderModal: false,
  onCreateFolderModal: false,
  pageCount: 0,
  errMessTemplates: '',
  isLoadFolder: false,
  templateFolders: [],
  isLoadTemplateFolders: false,
  choosedTemplateTags: [],
  selectedFolderId: 1,
  warningWhenDeleting: '*при удалении папки будут удалены все шаблоны находящееся в этой папке',
  isShowRecommendedTemplate: true,
  isOpenedTemplateTags: false,
  isOpenedDishTags: false,
};

export default (state = defaultStore, action) => {
  switch (action.type) {
    case constants.SET_ALL_FOLDERS: {
      return {
        ...state,
        folders: action.payload.folders,
        pageCount: action.payload.pages,
      };
    }
    case constants.SET_TEMPLATE_FOLDERS: {
      return {
        ...state,
        templateFolders: action.payload,
        isLoadTemplateFolders: false,
      };
    }
    case constants.OPEN_CREATE_FOLDER_MODAL: {
      return {
        ...state,
        onCreateFolderModal: true,
      };
    }
    case constants.GET_ALL_FOLDERS_ERROR:
      return {
        ...state,
        folders: [],
        pageCount: 0,
        errMessTemplates: action.payload.message,
      };
    case constants.CLOSE_CREATE_FOLDER_MODAL: {
      return {
        ...state,
        onCreateFolderModal: false,
      };
    }
    case constants.OPEN_ALL_FOLDER_MODAL: {
      return {
        ...state,
        onAllFolderModal: true,
      };
    }
    case constants.CLOSE_ALL_FOLDER_MODAL: {
      return {
        ...state,
        onAllFolderModal: false,
      };
    }
    case constants.IS_LOAD_FOLDER: {
      return {
        ...state,
        isLoadFolder: true,
      };
    }
    case constants.IS_LOAD_FOLDER_END: {
      return {
        ...state,
        isLoadFolder: false,
      };
    }
    case constants.IS_LOAD_TEMPLATE_FOLDERS: {
      return {
        ...state,
        isLoadTemplateFolders: true,
      };
    }
    case constants.SET_CHOOSED_TEMPLATE_TAGS: {
      return {
        ...state,
        choosedTemplateTags: action.payload.tags,
      };
    }
    case constants.CHANGE_FOLDER_SELECTION: {
      return {
        ...state,
        selectedFolderId: action.payload.selectedFolderId,
      };
    }
    case constants.IS_SHOW_RECOMMENDED_TEMPLATE: {
      return {
        ...state,
        isShowRecommendedTemplate: !state.isShowRecommendedTemplate,
      };
    }
    case constants.CLOSE_RECOMMENDED_TEMPLATE: {
      return {
        ...state,
        isShowRecommendedTemplate: false,
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/folders.js